<div class="card-container">
  <mat-card class="card-content" id="login_container">
    <mat-card-header>
      <img class="login__logo" src="assets/images/header.png">
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="loginForm">
        <mat-form-field class="full-width">
          <mat-label>{{'Username' | translate}}</mat-label>
          <input [ngClass]="{ 'is-invalid': submitted && f.username.errors }" class="form-control"
            formControlName="username" id="username" matInput
            type="text"/>
          @if (isFieldInvalid('username')) {
            <mat-error>
              {{'Username is mandatory.' | translate}}
            </mat-error>
          }
        </mat-form-field>
        <br>
          <mat-form-field class="full-width">
            <mat-label>{{'Password' | translate}}</mat-label>
            <input [ngClass]="{ 'is-invalid': submitted && f.password.errors }" class="form-control"
              formControlName="password" formControlName="password" matInput (keyup.enter)="login()"
              type="password"/>
            @if (isFieldInvalid('password')) {
              <mat-error>
                {{'Password is mandatory.' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <br>
            @if (error | async) {
              <mat-error class="alert alert-danger">{{error | async}}</mat-error>
            }
            <br>
              <p class="login-successful">{{loginSuccessMessage | async}}</p>
              @if (orgSelectionVisible) {
                <mat-form-field class="full-width">
                  <mat-label>{{'Select Organization' | translate}}</mat-label>
                  <mat-select (selectionChange)="onOrganizationChanged($event)"
                    [(ngModel)]="authenticationService.selectedOrganization"
                    [disabled]="authenticationService.organizationChangeDisabled"
                    formControlName="selectOrganization" id="selectOrganization"
                    name="selectOrganization" placeholder="">
                    @for (org of authenticationService.organizations; track org) {
                      <mat-option [value]="org.id">
                        {{org.orgName}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }

            </form>
            <mat-spinner [style.display]="loading ? 'block' : 'none'"></mat-spinner>
          </mat-card-content>
          <mat-card-actions>
            <button [disabled]="loginSuccessful"
              (click)="login()"
              type="button"
              color="primary"
              id="login"
              mat-raised-button> {{ 'Login' | translate }}
            </button>
          </mat-card-actions>
          <a mat-button routerLink="/reset-password" id="resetPassword">{{'Forgot Your Password?' | translate}}  </a>
        </mat-card>
      </div>
